<!-- Prefix icons (optional, tooltip support). -->
<div *ngIf="prefixIcon" class="phx-table-cell-string-prefix-icon">
  <ng-container *ngFor="let icon of prefixIcon; trackBy: trackByPrefixIconFn">
    <i
      *ngIf="icon.tooltipContent"
      phx-icon
      phx-tooltip
      [phxContent]="icon.tooltipContent"
      [phxIcon]="icon.icon"
      [size]="icon.size || 20"
      [color]="icon.intent ? 'var(--phx-web-color-content-' + icon.intent + ')' : ''"
    ></i>
    <i
      *ngIf="!icon.tooltipContent"
      phx-icon
      [phxIcon]="icon.icon"
      [size]="icon.size || 20"
      [color]="icon.intent ? 'var(--phx-web-color-content-' + icon.intent + ')' : ''"
    ></i>
  </ng-container>
</div>

<!-- Text content (primary, secondary, tertiary, inline icon). -->
<div class="phx-table-cell-string-text-content">
  <ng-container *ngTemplateOutlet="primaryTpl"></ng-container>
  <div *ngIf="phxSecondary" class="phx-table-cell-string-text-content-secondary">
    <ng-container *ngTemplateOutlet="subLinesTpl; context: { items: secondaryValue }"></ng-container>
  </div>
  <div *ngIf="phxTertiary" class="phx-table-cell-string-text-content-tertiary">
    <ng-container *ngTemplateOutlet="subLinesTpl; context: { items: tertiaryValue }"></ng-container>
  </div>
  <ng-container *ngIf="inlineIcon">
    <i
      *ngIf="!inlineIcon.tooltipContent"
      class="phx-table-cell-string-text-content-inline-icon"
      phx-icon
      [phxIcon]="inlineIcon.icon"
      [size]="inlineIcon.size || 16"
    ></i>
    <i
      *ngIf="inlineIcon.tooltipContent"
      class="phx-table-cell-string-text-content-inline-icon"
      phx-icon
      phx-tooltip
      [phxContent]="inlineIcon.tooltipContent"
      [phxIcon]="inlineIcon.icon"
      [size]="inlineIcon.size || 16"
    ></i>
  </ng-container>
</div>

<!-- Primary line: optionally wrapped in a routerLink anchor via phxPrimaryLink. -->
<ng-template #primaryTpl>
  <a
    *ngIf="phxPrimaryLink; else primaryPlain"
    class="phx-table-cell-string-link"
    [routerLink]="phxPrimaryLink"
    [target]="phxPrimaryLinkTarget || ''"
    (click)="$event.stopPropagation()"
  >
    <ng-container
      *ngTemplateOutlet="segmentTpl; context: { seg: primaryValue, size: 'medium', defaultIntent: 'active' }"
    ></ng-container>
  </a>
  <ng-template #primaryPlain>
    <ng-container *ngTemplateOutlet="segmentTpl; context: { seg: primaryValue, size: 'medium' }"></ng-container>
  </ng-template>
</ng-template>

<!-- Tooltip branch required: phx-tooltip is attribute-only and cannot be toggled by binding. -->
<ng-template #segmentTpl let-seg="seg" let-size="size" let-defaultIntent="defaultIntent">
  <phx-text
    *ngIf="seg.truncate || seg.tooltipContent || seg.maxLines"
    phx-tooltip
    phx-tooltip-on-truncate
    [phxContent]="seg.tooltipContent || seg.value"
    [phxTruncationTooltipDisabled]="!!seg.tooltipContent"
    [phxTooltipTruncateDirection]="seg.maxLines != null ? 'vertical' : 'horizontal'"
    [phxTextIntent]="seg.intent || defaultIntent"
    [phxEmphasis]="seg.emphasis"
    [phxItalic]="seg.italic"
    [phxDecoration]="seg.decoration"
    [phxTruncate]="seg.truncate"
    [phxMaxLines]="seg.maxLines"
    [phxSize]="size"
  >
    {{ seg.value }}
  </phx-text>
  <phx-text
    *ngIf="!seg.truncate && !seg.tooltipContent && !seg.maxLines"
    [phxTextIntent]="seg.intent || defaultIntent"
    [phxEmphasis]="seg.emphasis"
    [phxItalic]="seg.italic"
    [phxDecoration]="seg.decoration"
    [phxSize]="size"
  >
    {{ seg.value }}
  </phx-text>
</ng-template>

<!-- Secondary / tertiary sub-lines (small, bullet-separated). -->
<ng-template #subLinesTpl let-items="items">
  <ng-container *ngFor="let item of items; let isLast = last; trackBy: trackBySegment">
    <ng-container *ngTemplateOutlet="segmentTpl; context: { seg: item, size: 'small' }"></ng-container>
    <i *ngIf="!isLast && items.length > 1" phx-icon [phxIcon]="Bullet16Icon"></i>
  </ng-container>
</ng-template>
